export default function mapMeta(cmsData) {
	return {
		dataLayer: {
			essence_genre: cmsData?.dataLayer?.essenceGenre,
			genre_1: cmsData?.dataLayer?.magicGenre,
			imdb_id: cmsData?.dataLayer?.imdbId,
		},
		dates: {
			boxOffice: cmsData?.dates?.ticketing,
			release: cmsData?.dates?.release,
		},
		id: cmsData?.thundr_id,
		title: {
			locale: cmsData?.title,
			localeSlug: cmsData?.slug,
		},
	};
}